import { useState, Fragment } from "react";
import { Button } from "core/components/form-controls";
import BottomSwiper from "core/components/BottomSwiper";
import { _t } from "core/language";
import { sortBy } from './../../store/helper';
import { type TOption } from './../../store/types';
import ID from 'core/assets/icons/recipe/arrow_down.svg';

const MyIngredientFilter = ({sort, setSort}: any) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const toggleDrawer = () => {
    setIsDrawerOpen((prevState: boolean) => !prevState);
  };

  return (
    <Fragment>
      <Button
        label={_t(sort?.label)}
        onClickBtn={toggleDrawer}
        rounded
        size="11px"
        classBtn="px-3.5 flex-row-reverse !text-[11px] !font-medium py-[7px]"
        icon={ID}
        iconClassName={'ml-[7px]'}
      />

      <BottomSwiper
        title={_t('ingredient.filter_title')}
        isOpen={isDrawerOpen}
        toggleDrawer={toggleDrawer}
        zIndex={50}
      >
        <div className="flex flex-col gap-3 !mt-[-30px]">
          {sortBy.map((option: TOption) => (
            <Button
              key={option?.value}
              label={_t(option?.label)}
              classBtn="w-full"
              onClickBtn={() => {
                setSort(option);
                toggleDrawer();
              }}
              primary={sort?.value === option.value}
            />
          ))}
        </div>
      </BottomSwiper>
    </Fragment>
  )
}

export default MyIngredientFilter
